import { createSlice, Dispatch } from "@reduxjs/toolkit";
import {
  FilterAirportsQueryParams,
  PagedAirportsList,
} from "app/types/service-types/AirportServiceTypes";
import { AirportService } from "app/services";
import { errorMsg } from "../../../../utils/MessageUtils";

const getErrorMessage = (err: any): string => {
  // Axios typical shape: err.response.data
  const fromAxios =
    err?.response?.data?.message ||
    err?.response?.data?.error?.message ||
    err?.response?.data?.error_description ||
    err?.response?.data?.error;

  if (fromAxios) return String(fromAxios);

  // Some codebases throw { data: { message } }
  const fromData = err?.data?.message;
  if (fromData) return String(fromData);

  // Fallback
  if (err?.message) return String(err.message);

  return "Something went wrong. Please try again.";
};

export const fetchAllAirports =
  (queryParams?: FilterAirportsQueryParams) => async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      let response;
      if (queryParams && Object.keys(queryParams).length > 0) {
        response = await AirportService.filterAirports(queryParams);
      } else {
        response = await AirportService.fetchAll();
      }

      dispatch(setAirports(response));
    } finally {
      dispatch(setLoading(false));
    }
  };

interface AirportsListSlice {
  airports: PagedAirportsList;
  loading: boolean;
}

const initialState: AirportsListSlice = {
  airports: {
    content: [],
  },
  loading: false,
};

const stateSlice = createSlice({
  name: "configurations/airports",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAirports: (state, action) => {
      state.airports = action.payload;
    },
  },
});

export const { setLoading, setAirports } = stateSlice.actions;

export default stateSlice.reducer;
